export const TITLE_SUFFIX = ' | 外資就活ドットコム';

export * as routes from './routes';
